// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"53e239c9","329":"62927e75","542":"18173c83","588":"321ef752","963":"de8cec1b","980":"4cc62472"}[chunkId] + ".chunk.js";
};